module.exports = __webpack_public_path__ + "static/images/chevron-down.0c65b7ee9d21cf98a60f1f33a0571089.svg";